import type { LinkCardProps } from "@components/LinkCardProps.js";
import brackets from "@core/assets/icons/brackets.svg?raw";
import rentIt from "@core/assets/icons/rent-it.svg?raw";
import rescue from "@core/assets/icons/rescue.svg?raw";
import type { Tenant } from "@core/schema/Tenant.js";
import { getHireItTeamPath } from "@core/schema/paths/getHireItTeamPath.js";
import { getProjectRescuePath } from "@core/schema/paths/getProjectRescuePath.js";
import { getWebAppsPath } from "@core/schema/paths/getWebAppsPath.js";

export function getMainServices(tenant: Tenant): LinkCardProps[] {
	return [
		{
			title: "Pronájem IT týmu",
			iconName: rentIt,
			href: getHireItTeamPath(tenant),
			show: true,
		},
		{
			title: "Záchrana IT projektu",
			iconName: rescue,
			href: getProjectRescuePath(tenant),
			show: true,
		},
		{
			title: "Rozšíření týmu",
			iconName: rescue,
			href: getHireItTeamPath(tenant),
			show: true,
		},
		{
			title: "IT konzultace",
			iconName: brackets,
			show: true,
			href: getWebAppsPath(tenant),
		},
	];
}
